import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShapeSquareIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.12 19.84V4.08H19.88V19.84H4.12ZM5.96 18H18.04V5.92H5.96V18Z" />
    </SvgIcon>
  );
});
